<template>
  <span>
    <v-tooltip bottom open-delay="500">
      <button
        slot="activator"
        type="button"
        class="tw-inline-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-md tw-text-neutral-500 hover:tw-text-primary-400 hover:tw-bg-neutral-50 tw-transition-colors"
        @click="
          resetForm();
          dialog = true;
        "
      >
        <v-icon small>edit</v-icon>
      </button>
      <span>Edit</span>
    </v-tooltip>

    <ui-modal v-if="dialog" @close="closeDialog" modal-title="Edit User" custom-class="tw-max-w-3xl tw-w-full">
      <div class="tw-flex tw-flex-col tw-gap-6 tw-mt-4">
        <div class="tw-space-y-4">
          <ui-text-edit :label="$tc('_name')" v-model="name" :rules="[rules.required]"></ui-text-edit>
          <ui-text-edit :label="$tc('_email')" :value="user.email" disabled></ui-text-edit>
          <ui-select2
            :items="roles"
            :label="$tc('_role')"
            v-model="selectedRoles"
            keyField="id"
            labelField="name"
            keyOnly
            searchable
            multiple
            retainFocus
            checkboxes
          ></ui-select2>
          <!-- Wallets field hidden - backend functionality not working correctly -->
          <!-- <ui-select2
              :items="wallets"
              v-model="selectedWallets"
              class="tw-flex-1 tw-mr-2"
              style="min-width: 180px"
              keyField="id"
              labelField="name"
              label="Wallets"
              searchable
              keyOnly
              multiple
              retainFocus
              checkboxes
              :isValid="selectedWallets && selectedWallets.length <= 10"
              validationMessage="Maximum of 10 wallets can be selected"
              :v-if="checkFeatureFlag('advanced-rbac')"
            ></ui-select2> -->
          <ui-text-edit label="Asserted Identity" v-model="assertedIdentity"></ui-text-edit>
        </div>

        <!-- Identities Section -->
        <div v-if="user.identities && user.identities.length > 0">
          <div class="tw-text-sm tw-font-semibold tw-mb-2 tw-text-neutral-700">Identities</div>
          <div class="tw-border tw-border-neutral-200 tw-rounded tw-overflow-hidden">
            <table class="tw-w-full tw-text-xs tw-table-fixed">
              <colgroup>
                <col style="width: 12%" />
                <col style="width: 20%" />
                <col style="width: 18%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
              </colgroup>
              <thead class="tw-bg-neutral-50">
                <tr>
                  <th class="tw-text-left tw-px-3 tw-py-2 tw-font-semibold">Identity ID</th>
                  <th class="tw-text-left tw-px-3 tw-py-2 tw-font-semibold">Remote System</th>
                  <th class="tw-text-left tw-px-3 tw-py-2 tw-font-semibold">Type</th>
                  <th class="tw-text-left tw-px-3 tw-py-2 tw-font-semibold">Remote ID</th>
                  <th class="tw-text-left tw-px-3 tw-py-2 tw-font-semibold">Enabled</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(identity, index) in user.identities"
                  :key="identity.identityId || `identity-${index}`"
                  class="tw-border-t tw-border-neutral-100"
                >
                  <td class="tw-px-3 tw-py-2 tw-overflow-hidden">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="tw-block tw-truncate tw-cursor-help">{{
                          identity.identityId || '-'
                        }}</span>
                      </template>
                      <span>{{ identity.identityId || '-' }}</span>
                    </v-tooltip>
                  </td>
                  <td class="tw-px-3 tw-py-2 tw-overflow-hidden">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="tw-block tw-truncate tw-cursor-help">{{
                          identity.remoteSystem || '-'
                        }}</span>
                      </template>
                      <span>{{ identity.remoteSystem || '-' }}</span>
                    </v-tooltip>
                  </td>
                  <td class="tw-px-3 tw-py-2 tw-overflow-hidden">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="tw-block tw-truncate tw-cursor-help">{{ identity.type || '-' }}</span>
                      </template>
                      <span>{{ identity.type || '-' }}</span>
                    </v-tooltip>
                  </td>
                  <td class="tw-px-3 tw-py-2 tw-overflow-hidden">
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on" class="tw-truncate tw-flex-1 tw-min-w-0 tw-cursor-help">
                            {{ formatRemoteId(identity.remoteId) }}
                          </span>
                        </template>
                        <span>{{ formatRemoteId(identity.remoteId) }}</span>
                      </v-tooltip>
                      <i
                        class="fa fa-clipboard hover:tw-text-neutral-500 tw-text-neutral-300 tw-cursor-pointer tw-flex-shrink-0"
                        v-clipboard:copy="formatRemoteId(identity.remoteId)"
                        v-clipboard:success="() => showSuccessSnackbar($t('_clipboardSuccess'))"
                        v-clipboard:error="() => showErrorSnackbar($t('_clipboardFail'))"
                      ></i>
                    </div>
                  </td>
                  <td class="tw-px-3 tw-py-2">
                    <span
                      class="tw-inline-block tw-px-2 tw-py-1 tw-rounded tw-text-white tw-font-semibold tw-text-xs"
                      :class="identity.enabled ? 'tw-bg-green-500' : 'tw-bg-red-500'"
                    >
                      {{ identity.enabled ? 'Yes' : 'No' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tw-flex tw-justify-end tw-gap-3 tw-pt-4 tw-border-t tw-border-gray-200">
          <ui-button color="secondary" @click.native="closeDialog">Cancel</ui-button>
          <ui-button color="primary" :loading="loading" @click.native.stop="save" :disabled="!canSave">
            Save
          </ui-button>
        </div>
      </div>
    </ui-modal>
  </span>
</template>

<script>
import gql from 'graphql-tag';

import { WalletsQuery } from '../../queries/transactionsPageQuery';
import UiButton from '../ui/UiButton.vue';
import UiModal from '../ui/UiModal.vue';
import UiSelect2 from '../ui/UiSelect2.vue';
import UiTextEdit from '../ui/UiTextEdit.vue';
import { formatRemoteId as formatIdentityRemoteId } from './userIdentity';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: this.user.name,
      assertedIdentity: this.user.assertedIdentity,
      valid: false,
      rules: {
        required: (v) => !!v || 'Field is required',
      },
      // roles: ['Read-only', 'Standard User', 'Writer', 'Owner', 'Admin', 'Advanced User'],
      roles: [],
      // rolesFiltered: ['Read-only', 'Standard User', 'Admin', 'Advanced User'],
      selectedRoles: this.user.role.map((r) => r.id),
      isLoadingWallets: 0,
      isRolesLoading: 0,
      selectedWallets: this.user.walletIds,
      wallets: [],
    };
  },
  computed: {
    canSave() {
      return (
        this.name !== this.user.name ||
        this.selectedRoles !== this.user.role ||
        this.assertedIdentity !== this.user.assertedIdentity
        // selectedWallets comparison removed - field hidden
      );
    },
  },
  methods: {
    formatRemoteId(remoteId) {
      return formatIdentityRemoteId(remoteId) || '-';
    },
    async save() {
      this.loading = true;

      let nameMutation = Promise.resolve();
      const roleMutation = Promise.resolve();
      let assertIdMutation = Promise.resolve();

      if (this.name !== this.user.name) {
        nameMutation = this.$apollo.mutate({
          // Query
          mutation: gql`
            mutation ($userId: ID!, $user: UserInput!) {
              updateUser(userId: $userId, user: $user) {
                success
                errors
              }
            }
          `,
          // Parameters
          variables: {
            userId: this.user.id,
            user: {
              displayName: this.name,
            },
          },
        });
      }

      // if (this.role !== this.user.role) {
      //   roleMutation = this.$apollo.mutate({
      //     mutation: gql`
      //       mutation ($orgId: ID!, $userRoles: [UserRoleInput]!) {
      //         updateOrg(orgId: $orgId, userRoles: $userRoles) {
      //           id
      //           userRoles {
      //             role
      //           }
      //         }
      //       }
      //     `,
      //     variables: {
      //       orgId: this.$store.state.currentOrg.id,
      //       userRoles: [
      //         {
      //           userId: this.user.id,
      //           role: this.roles.indexOf(this.role),
      //         },
      //       ],
      //     },
      //   });
      // }

      // if (this.assertedIdentity !== this.user.assertedIdentity) {
      assertIdMutation = this.$apollo.mutate({
        mutation: gql`
          mutation ($orgId: ID!, $userId: ID!, $orgUser: OrgUserInput!) {
            updateOrgUser(orgId: $orgId, userId: $userId, orgUser: $orgUser) {
              id
            }
          }
        `,
        variables: {
          orgId: this.$store.state.currentOrg.id,
          userId: this.user.id,
          orgUser: {
            assertedIdentity: this.assertedIdentity,
            role: this.selectedRoles,
            // walletIds: this.selectedWallets, // Removed - backend functionality not working
          },
        },
      });
      // }

      let error;

      await Promise.all([nameMutation, roleMutation, assertIdMutation])
        .then(([r1, r2, r3]) => {
          error = r1?.errors || r2?.errors || r3?.errors;
        })
        .catch((err) => {
          error = err;
        });

      this.loading = false;

      if (error) {
        this.showErrorSnackbar('Failed to edit the user. Please try again later');
      } else {
        this.showSuccessSnackbar('User is successfully updated!');
        this.closeDialog();
      }
    },

    closeDialog() {
      this.resetForm();
      this.dialog = false;
      this.$emit('completed');
    },

    resetForm() {
      this.name = this.user.name;
      this.selectedRoles = this.user.role.map((r) => r.id);
      this.assertedIdentity = this.user.assertedIdentity;
      this.selectedWallets = this.user.walletIds;
    },
  },
  apollo: {
    wallets: {
      query: WalletsQuery,
      variables() {
        return {
          orgId: this.$store.state.currentOrg.id,
        };
      },
      update(data) {
        return [{ id: 'All', name: 'All Wallets' }, ...data.wallets.map((w) => ({ id: w.id, name: w.name }))];
      },
      loadingKey: 'isLoadingWallets',
    },
    roles: {
      query: gql`
        query getRoles($orgId: ID!) {
          roles(orgId: $orgId) {
            id
            name
            description
          }
        }
      `,
      variables() {
        return {
          orgId: this.$store.state.currentOrg.id,
        };
      },
      update(data) {
        return [...data.roles].sort((a, b) =>
          (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
        );
      },
      loadingKey: 'isRolesLoading',
    },
  },
  components: {
    UiSelect2,
    UiTextEdit,
    UiButton,
    UiModal,
  },
};
</script>
